import React, { Fragment, useState } from 'react';
import { useTranslate, useRecordContext, minLength, useNotify, Button,
        SimpleForm, useRefresh, TextInput, } from 'react-admin';
import IconFileCopy from '@mui/icons-material/FileCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import dataProvider from '../dataProvider';
import NoDeleteToolbar from '../../lib/NoDeleteToolbar';

const PricegrCopy = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const record = useRecordContext();

  const [showDialog, setShowDialog] = useState(false);

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
  
  const doSave = (data) => {
    dataProvider.update('calPricegr', { id:record.id, data:data })
      .then(({ data }) => {
        setShowDialog(false);
        refresh();
      })
      .catch(error => {
        notify(error.message, 'error');
      })
  };

  if (!record) return null;
  const prefillTitle = 'Copy of '+record.bezeichnung;
  const prefillMwst = record.mwst;
  return (
    <Fragment>
      <Button onClick={handleClick} label="glob.copy">
        <IconFileCopy />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="bw.cal.pricegr.copytitle" >
        <DialogTitle>{translate("bw.cal.pricegr.copytitle")}</DialogTitle>
        <DialogContent>
          <SimpleForm onSubmit={doSave} toolbar={<NoDeleteToolbar />} >
            <Fragment>
              <h3>{record.bezeichnung}</h3>
              <div>{translate('bw.cal.pricegr.copyinfo')}</div>
            </Fragment>
            <TextInput source="copyTitle" defaultValue={prefillTitle} validate={minLength(1)} />
            <TextInput source="copyMwst" defaultValue={prefillMwst} validate={minLength(1)} />
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

export default PricegrCopy;
